import utils from "@/resources/utils";

const selectChoices = state => {
  var data = {};

  data = {
    specie: utils.object2Array(state.choices.specie),
    gender: utils.object2Array(state.choices.gender),
    body_condition: utils.object2Array(state.choices.body_condition),
    hydration_status: utils.object2Array(state.choices.hydration_status),
    type_plan_therapeutic: utils.object2Array(
      state.choices.type_plan_therapeutic
    ),
    inventory_type: utils.object2Array(state.choices.inventory_type)
  };

  return data;
};

let getters = {
  selectChoices
};

export default getters;
